import React from 'react';

import { Notification } from './Notification';
import { getCurrencyFormat } from '../helpers/getCurrencyFormat';
import { interpolateAppText, useAppTexts } from '../hooks/useAppTexts';
import { SelectedMontaOption } from '../../../../functions/src/shared';
import { useLanguage } from '../hooks/useLanguage';

export const MontaPaymentRequired = ({
  returnOption,
  inline = false,
}: {
  returnOption: SelectedMontaOption;
  inline?: boolean;
}) => {
  const appTexts = useAppTexts();
  const { language, languageSettingsEnabled } = useLanguage();

  if (!returnOption.price || returnOption.price.amount === 0) return null;

  const montaLabelPrice = getCurrencyFormat(
    returnOption.price.amount / 100,
    returnOption.price.currency,
    language,
  );
  const montaCarrier = languageSettingsEnabled
    ? returnOption.labelTranslated?.[language] || returnOption?.label || ''
    : returnOption?.label || '';

  return (
    <div className={inline ? '' : 'shipping-label-paid'}>
      <Notification status="info">
        {interpolateAppText(appTexts.shippingLabel.isPaidLabel, {
          amount: montaLabelPrice,
          carrier: montaCarrier,
        })}
      </Notification>
    </div>
  );
};
